/**
 * useDefaultDashboardRoute
 *
 * Returns the correct landing route for the current user after login or
 * after an organisation context switch.
 *
 * Roles with `org:create_project` (ORG_ADMIN, COMPLIANCE_MANAGER,
 * ASSURANCE_MANAGER, GOVERNANCE_MANAGER) land on the compliance dashboard.
 *
 * MEMBER and AUDITOR lack `org:create_project`, so they land on the tasks
 * page — the only main-dashboard view that is useful to them.
 *
 * Returns `null` while permissions are still loading so callers can wait
 * before navigating.
 */
import { usePermissions } from '~/client/contexts/permissions-context';

export const COMPLIANCE_DASHBOARD_PATH = '/dashboard/compliance';
export const TASKS_DASHBOARD_PATH = '/dashboard/tasks';

export function useDefaultDashboardRoute(): string | null {
  const { hasCapability, loading } = usePermissions();

  if (loading) {
    return null;
  }

  return hasCapability('org:create_project')
    ? COMPLIANCE_DASHBOARD_PATH
    : TASKS_DASHBOARD_PATH;
}
